// Typed table figure for the note viewer (figures mockup). Data is typed (NoteTable from the
// distiller) — cells render as React-escaped text, never HTML. Also serves as NoteChartView's
// degradation target for malformed charts.

import type { NoteTable } from '../../lib/note-doc';

export function NoteTableView({ table }: { table: NoteTable }) {
  return (
    <figure className="nd-fig">
      <figcaption className="nd-fig-cap"><b>Table</b> · {table.caption}</figcaption>
      <div className="nd-table-scroll">
        <table className="nd-table">
          <thead><tr>{table.columns.map((c, i) => <th key={i}>{c}</th>)}</tr></thead>
          <tbody>{table.rows.map((r, i) => (
            <tr key={i}>{r.map((cell, j) => <td key={j}>{cell}</td>)}</tr>
          ))}</tbody>
        </table>
      </div>
    </figure>
  );
}
